import { useTheme } from '@root/context/ThemeContext';
import { capitalizeFirstLetter } from '@root/utilities/string';
import { PieChart, Pie, Tooltip, Cell } from 'recharts';
// import Text from '@root/components/v2/ui-elements/Text';
import isEmpty from 'lodash/isEmpty';

const PieCharts = props => {
  const {
    chartData,
    count_msg,
    count_value,
    colors,
    capitalizeTooltipText = true,
    onlyCount = false,
    height = 190,
    middleCountTextSize = '22px',
    width = 190,
    valueInPercentage,
    innerRadius = 61,
    outerRadius = 70,
  } = props;
  const { isDarkMode } = useTheme();
  function kFormatter(num) {
    const absNum = Math.abs(num);
    const signPrefix = num < 0 ? '-' : '';

    if (absNum < 1000) {
      return String(num); // Return original number as string
    }

    // Values >= 1000
    const numInK = absNum / 1000;

    // Format to one decimal place, toFixed will also handle rounding
    let s = numInK.toFixed(1);

    // If it ends with ".0", remove the ".0"
    // e.g., "17.0" becomes "17", "1.0" becomes "1"
    if (s.endsWith('.0')) {
      s = s.substring(0, s.length - 2);
    }
    // e.g., "1.2" remains "1.2"

    return signPrefix + s + 'k';
  }

  const CustomTooltip = ({ active, payload, capitalizeTooltipText }) => {
    if (active && payload && payload.length) {
      if (payload[0]?.name === 0) return <></>;
      const labelColor = colors[payload[0]?.name];
      return (
        <div className="custom_tooltip" style={{ outline: 0 }}>
          <div className="count_container">
            <p
              className="custom_tooltip_severity m-0"
              style={{ borderLeft: `4px solid ${labelColor} `, paddingLeft: '4px', borderRadius: '1px' }}>
              {capitalizeTooltipText ? capitalizeFirstLetter(payload[0]?.name) : payload[0]?.name} :{' '}
              <span className="custom_tooltip_count"> {payload[0]?.value}</span>
            </p>
          </div>
        </div>
      );
    }

    return null;
  };

  const isDataEmpty = isEmpty(chartData) || chartData.every(item => item.value === 0);

  return (
    <div className="inventory_new">
      <PieChart height={height} width={width}>
        <Pie
          dataKey="value"
          data={isDataEmpty ? [{ name: 'No Data', value: 1 }] : chartData}
          cx="50%"
          cy="50%"
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          fill="#82ca9d"
          labelLine={false}
          isAnimationActive={false}
          stroke={{
            width: 0.1,
            color: '#808080',
          }}
          activeIndex={0}>
          {isDataEmpty ? (
            <Cell fill="#D3D3D3" />
          ) : (
            chartData?.map(d => <Cell key={`cell-${d.name}`} fill={colors[d.name] || '#f00'} fillOpacity={1} />)
          )}
        </Pie>
        {!isDataEmpty && <Tooltip content={<CustomTooltip capitalizeTooltipText={capitalizeTooltipText} />} />}
        {/* {count_value && ( */}
        <text
          x="50%"
          y={onlyCount ? '50%' : '45%'}
          textAnchor="middle"
          dominantBaseline="middle"
          style={{
            fill: isDarkMode ? 'var(--donut-dark-text)' : '#484D56',
            fontFamily: 'Manrope',
            fontSize: middleCountTextSize,
            fontWeight: 800,
          }}>
          {count_value !== null && count_value !== undefined && <title>{count_value}</title>}
          {count_value && valueInPercentage ? count_value : kFormatter(count_value)}
        </text>
        {/* // )} */}
        {count_msg && (
          <text
            x="50%"
            y="55%"
            textAnchor="middle"
            dominantBaseline="middle"
            style={{
              fill: isDarkMode ? 'var(--donut-dark-text)' : '#484D56',
              fontFamily: 'Manrope',
              fontSize: '12px',
              fontWeight: 600,
            }}>
            {count_msg}
          </text>
        )}
      </PieChart>
    </div>
  );
};

export default PieCharts;
